// extracted by mini-css-extract-plugin
export default {"BrowsingBanner":"BrowsingBanner_BrowsingBanner__N3+2D","text":"BrowsingBanner_text__7nYKQ","action":"BrowsingBanner_action__UmC1j"};